/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { on } from "ts-action-immer";
import { reducer, union } from "ts-action";
import { PersonalizationReducerState, Colors } from "../types";
import {
  receiveServerPersonalization,
  restoreDefaultColors,
  setColors,
  updatePersonalization,
  updatePersonalizationInfo,
  updatePersonalizationTitle,
} from "../actionCreators";
import colorsReducer from "./colorsReducer";

const initialState: PersonalizationReducerState | null = null;

const serverPersonalizationDataReducer = reducer(
  initialState,
  on(
    receiveServerPersonalization,
    (state: PersonalizationReducerState | null, action) => {
      const { primaryColor, secondaryColor, bgColor, ...rest } =
        action.payload.personalizationData;

      const colors: Colors = {
        primaryColor,
        secondaryColor,
        bgColor,
      };

      return {
        colors: colorsReducer(colors, action)!,
        ...rest,
      };
    }
  ),
  on(updatePersonalization, (state, action) => ({
    ...action.payload.updatedData,
  })),
  on(...union(setColors, restoreDefaultColors), (state, action) => {
    if (state === null) return;
    state.colors = colorsReducer(state.colors, action)!;
  }),
  on(
    updatePersonalizationTitle,
    (state, { payload: { newTitle, localization } }) => {
      if (state === null) return;

      if (localization === "cs") {
        state.homePageTitle.cz = newTitle;
      }

      if (localization === "en") {
        state.homePageTitle.en = newTitle;
      }
    }
  ),
  on(
    updatePersonalizationInfo,
    (state, { payload: { newInfo, localization } }) => {
      if (state === null) return;

      if (localization === "cs") {
        state.homePageInfo.cz = newInfo;
      }

      if (localization === "en") {
        state.homePageInfo.en = newInfo;
      }
    }
  )
);

export default serverPersonalizationDataReducer;
